// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-danger>h5,.text-danger>label{color:red}.withdraw{background-image:linear-gradient(90deg,#d63232,#e63636)!important;color:#fff;border-color:tomato}.disabled{pointer-events:none;opacity:.3}", ""]);
// Exports
module.exports = exports;
